<template>
  <div class="region-tutorial-ios">
    <h2 class="region-tutorial-ios-title">更改 Apple ID 国家或地区教程</h2>
    <div class="region-tutorial-ios-content">
      <div class="rtic-item">
        <img src="../../../static/img/regionTutorialIos/img_login.png" alt="rti-img-login" class="rtic-item-img" />
        <div class="rtic-item-content">
          <h3 class="rtic-item-content-title">第 1 步</h3>
          <div class="title">登录 Apple ID</div>
          <div class="rtic-item-content-text">
            <p>
              进入 Apple 官网
              <a href="https://appleid.apple.com" target="_blank" class="link-color">https://appleid.apple.com</a> 登录自己的 Apple ID
            </p>
          </div>
        </div>
      </div>
      <div class="rtic-item">
        <img src="../../../static/img/regionTutorialIos/img_select.png" alt="rti-img-select" class="rtic-item-img" />
        <div class="rtic-item-content">
          <h3 class="rtic-item-content-title">第 2 步</h3>
          <div class="title">选择个人信息</div>
          <div class="rtic-item-content-text">
            <p>登录成功后选择【个人信息】继续</p>
          </div>
        </div>
      </div>
      <div class="rtic-item">
        <img src="../../../static/img/regionTutorialIos/img_enter.png" alt="rti-img-enter" class="rtic-item-img" />
        <div class="rtic-item-content">
          <h3 class="rtic-item-content-title">第 3 步</h3>
          <div class="title">进入国家或地区更改页面</div>
          <div class="rtic-item-content-text">
            <p>点击【国家或地区】，之后点击【更改国家或地区】进入付款方式信息填写页面</p>
          </div>
        </div>
      </div>
      <div class="rtic-item">
        <img src="../../../static/img/regionTutorialIos/img_modify.png" alt="rti-img-modify" class="rtic-item-img" />
        <div class="rtic-item-content">
          <h3 class="rtic-item-content-title">第 4 步</h3>
          <div class="title">更改国家或地区到 Hong Kong（香港）</div>
          <div class="rtic-item-content-text">
            <ul>
              <li>【国家或地区】选择【香港】；</li>
              <li>【付款方式】选择【无】；</li>
              <li>地址和姓名可随意填写；</li>
              <li>地区码为 852，电话号码是 8 位，必须为 9 或者 6 开头</li>
              <li>填写完信息之后点击【更新】，保存信息</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="rtic-item">
        <img src="../../../static/img/regionTutorialIos/img_check.png" alt="rti-img-check" class="rtic-item-img" />
        <div class="rtic-item-content">
          <h3 class="rtic-item-content-title">第 5 步</h3>
          <div class="title">查看更改后的信息</div>
          <div class="rtic-item-content-text">
            <p>保存信息后即可返回查看自己账号的地区是否已修改为香港</p>
          </div>
        </div>
      </div>
      <div class="rtic-item">
        <img src="../../../static/img/regionTutorialIos/img_download.png" alt="rti-img-download" class="rtic-item-img" />
        <div class="rtic-item-content">
          <h3 class="rtic-item-content-title">第 6 步</h3>
          <div class="title">下载 Plex加速器</div>
          <div class="rtic-item-content-text">
            <p>信息修改完成之后，您便可以打开 App Store，搜索 PlexVPN 并下载安装</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    language() {
      return this.$store.state.currentLang;
    }
  },
  mounted() {
    if (this.language !== 'zh') {
      this.$router.push('/');
    }
  }
};
</script>

<style lang="scss" scoped>
.region-tutorial-ios {
  padding: 1.6rem .24rem 1.8rem;
  font-size: 0.14rem;
  .region-tutorial-ios-title {
    margin: 0;
    text-align: center;
    font-size: 40px;
    color: #111111;
    line-height: 40px;
    font-weight: 600;
  }
  .region-tutorial-ios-content {
    margin-top: 0.8rem;
    .rtic-item {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      .rtic-item-img {
        width: 25%;
      }
      .rtic-item-content {
        margin-left: 0.14rem;
        width: 30%;
        .rtic-item-content-title {
          margin: .24rem 0 0;
          width: 84px;
          height: 28px;
          line-height: 28px;
          font-size: 16px;
          color: #FFFFFF;
          font-weight: 600;
          text-align: center;
          background-image: linear-gradient(135deg, #416CF8 0%, #EC55FF 100%);
          border-radius: 16px;
        }
        .title {
          margin-top: 0.24rem;
          font-size: 20px;
          line-height: 30px;
          color: #295FFD;
        }
        .rtic-item-content-text {
          margin-top: 0.16rem;
          font-size: 20px;
          line-height: 30px;
          p, ul {
            margin-bottom: 0;
          }
          .link-color {
            color: #295FFD;
          }
          ul {
            padding-left: 25px;
            li {
              margin-top: .16rem;
              &::marker {
                font-size: 25px;
                color: #999;
              }
            }
          }
        }
      }
    }
    .rtic-item ~ .rtic-item {
      margin-top: 0.8rem;
    }
  }

  @media screen and (max-width: 991px) {
    padding: 0.4rem 0.24rem 0.8rem;
    .region-tutorial-ios-title {
      font-size: 24px;
      line-height: 32px;
    }
    .region-tutorial-ios-content {
      margin-top: 0.4rem;
      .rtic-item {
        flex-direction: column-reverse;
        .rtic-item-img {
          margin-top: -0.12rem;
          width: 100%;
        }
        .rtic-item-content {
          width: 100%;
          margin-left: 0;
          text-align: center;
          .rtic-item-content-title {
            margin: 0 auto;
          }
          .title {
            margin-top: 0.16rem;
            font-size: 16px;
            line-height: 24px;
          }
          .rtic-item-content-text {
            margin-top: 0.12rem;
            font-size: 14px;
            line-height: 22px;
            ul {
              padding-left: 0;
              li {
                margin-top: 0.08rem;
                list-style: none;
                &:not(:last-child) {
                  padding-bottom: 18px;
                  background: url('/static/img/regionTutorialIos/ic_down.png') center bottom / 9px 10px no-repeat;
                }
              }
            }
          }
        }
      }
      .rtic-item ~ .rtic-item {
        margin-top: 0.16rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// regionTutorialIOS.vue?03400b0d